import axiosInstance from "../../api/axios";

const data = (promise) => promise.then((response) => response.data);

const EXPENSES = "/expense-manager/expenses";

const multipart = (file, kind, onProgress) => {
  const formData = new FormData();
  formData.append("file", file);
  if (kind) formData.append("kind", kind);
  return {
    formData,
    config: {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (event) => {
        if (onProgress && event.total) {
          onProgress(Math.round((event.loaded * 100) / event.total));
        }
      },
    },
  };
};

const ExpenseManagerService = {
  getMeta: () => data(axiosInstance.get("/expense-manager/meta")),

  getDashboard: (params) => data(axiosInstance.get("/expense-manager/dashboard", { params })),
  getExpenses: (params) => data(axiosInstance.get(EXPENSES, { params })),
  getExpense: (id) => data(axiosInstance.get(`${EXPENSES}/${id}`)),
  createExpense: (payload) => data(axiosInstance.post(EXPENSES, payload)),
  updateExpense: (id, payload) => data(axiosInstance.patch(`${EXPENSES}/${id}`, payload)),
  expenseAction: (id, payload) => data(axiosInstance.post(`${EXPENSES}/${id}/action`, payload)),
  deleteExpense: (id) => data(axiosInstance.delete(`${EXPENSES}/${id}`)),

  addPayment: (id, payload) => data(axiosInstance.post(`${EXPENSES}/${id}/payments`, payload)),
  linkGl: (id, payload) => data(axiosInstance.put(`${EXPENSES}/${id}/gl-link`, payload)),

  getAttachments: (id) => data(axiosInstance.get(`${EXPENSES}/${id}/attachments`)),
  uploadAttachment: (id, file, kind, onProgress) => {
    const { formData, config } = multipart(file, kind, onProgress);
    return data(axiosInstance.post(`${EXPENSES}/${id}/attachments`, formData, config));
  },
  deleteAttachment: (id, attachmentId) =>
    data(axiosInstance.delete(`${EXPENSES}/${id}/attachments/${attachmentId}`)),
  downloadAttachment: (id, attachmentId) =>
    axiosInstance.get(`${EXPENSES}/${id}/attachments/${attachmentId}`, { responseType: "blob" }),

  getSuppliers: (params) => data(axiosInstance.get("/expense-manager/suppliers", { params })),
  getGlCandidates: (params) => data(axiosInstance.get("/expense-manager/gl-candidates", { params })),

  getCategories: () => data(axiosInstance.get("/expense-manager/categories")),
  createCategory: (payload) => data(axiosInstance.post("/expense-manager/categories", payload)),
  updateCategory: (id, payload) => data(axiosInstance.patch(`/expense-manager/categories/${id}`, payload)),
  deleteCategory: (id) => data(axiosInstance.delete(`/expense-manager/categories/${id}`)),

  getRecurring: (params) => data(axiosInstance.get("/expense-manager/recurring", { params })),
  createRecurring: (payload) => data(axiosInstance.post("/expense-manager/recurring", payload)),
  updateRecurring: (id, payload) => data(axiosInstance.patch(`/expense-manager/recurring/${id}`, payload)),
  generateRecurring: () => data(axiosInstance.post("/expense-manager/generate-recurring")),
};

export default ExpenseManagerService;
